export default {"src":"/_next/static/media/SKX.73243a34.svg","height":18,"width":18};